import {
  IListInvoicesByBillingAccountQuery,
  IListInvoicesByBillingAccountQueryVariables,
} from "@/generated/types";
import { watchListObjectsFactory } from "../internal-utils";
import LIST_INVOICES_BY_BILLING_ACCOUNT from "./list_invoice_by_billing_account.graphql";
import { isNotNullable } from "@/utils";

export const watchInvoicesByBillingAccountQuery = watchListObjectsFactory<
  IListInvoicesByBillingAccountQuery,
  IListInvoicesByBillingAccountQueryVariables,
  NonNullable<
    NonNullable<
      IListInvoicesByBillingAccountQuery["listInvoicesByBillingAccount"]
    >["items"]
  >[number]
>(
  LIST_INVOICES_BY_BILLING_ACCOUNT,
  (result) => {
    const items =
      result.listInvoicesByBillingAccount?.items?.filter(isNotNullable) ?? [];
    const nextToken = result.listInvoicesByBillingAccount?.nextToken ?? null;

    return { items, nextToken };
  },
  (updatedResult) => ({
    listInvoicesByBillingAccount: {
      items: updatedResult.items,
      nextToken: updatedResult.nextToken,
    },
  }),
);
